<template>
  <div class="header">
    <div class="container">
      <div class="left-container">
        <span>
        <img
          @click="link(index_url, false)"
          :id="eventlogoId"
          class="logo_img"
          src="/images/anniversary2023/header/左Logo.svg"
          style="margin-top: 11px;"
        />
        </span>
        <span class="menu" @click.stop.prevent="onClickMenu">
          <img src="/images/anniversary2023/other/menu.svg" />
        </span>
      </div>
      <div class="menu-container-desktop">
        <div class="debug" v-show="isdebug == 1" style="position:fixed; top: 10px; left: 50%">
          <div class="mcd-link">
            <span class="mlink" @click="mission('mission1')">任務1</span>
          </div>
          <div class="mcd-link">
            <span class="mlink" @click="mission('mission2')">任務2</span>
          </div>
        </div>
        <div class="mcd-link" v-show="!showLogout">
          <span
            class="mlink"
            @click="link(comics_url, true)"
            :id="headerComicsId"
            >漫畫星</span
          >
        </div>
        <div class="mcd-link" v-show="!showLogout">
          <span
            class="mlink"
            @click="link(novels_url, true)"
            :id="headerNovelsId"
            >文學星</span
          >
        </div>
        <div class="mcd-link">
          <span class="mlink" v-show="showLogin" :id="loginId" @click="login()"
            >註冊 • 登入</span
          >
          <div class="nickNameArea-d" v-show="showLogout">
              <div>
                <span
                  class="mlink"
                  @click="link(comics_url, true)"
                  :id="headerComicsId"
                  >漫畫星</span
                >
                <span
                  class="mlink"
                  @click="link(novels_url, true)"
                  :id="headerNovelsId"
                  >文學星</span
                >
                <img class="nickNameImg" :src="nickNameImage" 
                    @mouseenter="isAreaIn=false;isShowLogoutDropDown=true;" 
                    @mouseleave="onDisappearPopup();"
                />
                <a class="showNNickName" href="javascript:void(0)" 
                    @mouseenter="isAreaIn=false;isShowLogoutDropDown=true;" 
                    @mouseleave="onDisappearPopup();"
                    style="color: #fff">
                  {{ nickName }}
                </a>
              </div>
              <transition
                  appear
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="dropdown-menu" v-if="isShowLogoutDropDown">
                    <div :id="logoutId" 
                    @click=" isShowLogoutDropDown = false; logout();"
                    @mouseenter="isAreaIn=true;isShowLogoutDropDown=true;" 
                    @mouseleave="isShowLogoutDropDown=false; "
                      >登出
                    </div>
                </div>
              </transition>
              <!--
              <template #list>
                <DropdownMenu>
                  <DropdownItem :id="logoutId" @click="logout()"
                    >登出</DropdownItem
                  >
                </DropdownMenu>
              </template>-->
          </div>




          <!-- test begin-->
          <!-- <div class="nickNameArea">
            <Dropdown>
              <div>
              <img class="nickNameImg" :src="nickNameImage" />
              <a class="showNNickName" href="javascript:void(0)" style="color: #fff">
                測試測試測試
              </a>
              </div>
              <template #list>
                <DropdownMenu>
                  <DropdownItem :id="logoutId" @click="logout()"
                    >登出</DropdownItem
                  >
                </DropdownMenu>
              </template>
            </Dropdown>
          </div> -->
          <!-- test end-->
        </div>
      </div>
      <div class="menu-container-mobile" v-if="isShowMenu">
        <div class="mcm-close" @click.stop.prevent="onClickMenu">
          <img
            class="mcm-close-img"
            src="/images/anniversary2023/icons/X.svg"
          />
        </div>
        <div class="mcm-link">
          <span
            class="mlink-login"
            v-show="showLogin"
            :id="loginId"
            @click="login()"
            >註冊 • 登入</span
          >
          <div class="nickNameArea" v-show="showLogout">
            <img class="nickNameImg" :src="nickNameImage" />
            <a class="showNNickName" href="javascript:void(0)" style="color: #fff">
              {{ nickName }}
            </a>
          </div>
        </div>
        <div class="mcm-link">
          <span
            class="mlink"
            @click="link(comics_url, true)"
            :id="headerComicsId"
            >漫畫星</span
          >
        </div>
        <div class="mcm-link">
          <span
            class="mlink"
            @click="link(novels_url, true)"
            :id="headerNovelsId"
            >文學星</span
          >
        </div>
        <div class="mcm-link" v-show="showLogout">
          <span class="mlink" @click="logout()" :id="logoutId">登出</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import * as login from "@/api/login";
import { loginUrl, openLink } from "@/lib/Utils";

import { defineComponent, computed /*, onMounted*/, ref } from "vue";

export default {
  name: "Header",
  props: {
    prefix: String,
  },
  data() {
    return {
      comics_url: import.meta.env.VITE_COMICS_URL, // 漫畫星轉址
      novels_url: import.meta.env.VITE_NOVELS_URL, // 文學星轉址
      nickName: "", // 會員名稱
      showLogin: true, // 是否顯示登入的區塊
      showLogout: false, // 是否顯示登出的區塊
      nickNameImage: "/images/anniversary2023/icons/avatar_default.svg", // 預設頭貼
      index_url: import.meta.env.VITE_COMICS_URL + import.meta.env.VITE_BASE,
      loginId: this.prefix + "login",
      logoutId: this.prefix + "logout",
      eventlogoId: this.prefix + "eventlogo",
      headerComicsId: this.prefix + "header_comics",
      headerNovelsId: this.prefix + "header_novels",
      isdebug: import.meta.env.VITE_DEBUG_MODE,
      ssrMode: import.meta.env.SSR,
      baseUrl: import.meta.env.VITE_BASE
    };
  },
  mounted() {
    //console.log('ssr mode:' + this.ssrMode)
    // 撈取個人資料
    login.nickName().then((response: any) => {
      if (response.code === 0) {
        this.nickName = response.data.nickname;
        // 如登入者有設定頭貼則置換圖示
        if (null != response.data.avatar && "" != response.data.avatar) {
          this.nickNameImage = response.data.avatar;
        }
        localStorage.setItem("isLogin", "true");
        this.showLogin = false;
        this.showLogout = true;
      } else {
        localStorage.setItem("isLogin", "false");
        this.showLogin = true;
        this.showLogout = false;
      }
    });
  },
  methods: {
    // 開啟外部連結
    link(url: string, open: boolean) {
      openLink({ url: url, open: open });
    },
    // 登入事件
    login() {
      // 延遲一下再跳轉，讓埋點資訊能順利傳出
      setTimeout(() => {
        // openLink({ url: loginUrl({}), open: false });
        //console.log("目前連結~~~~~:", this.$route.fullPath);
        let path = this.$route.fullPath.replace('/',"");
        openLink({
          url: loginUrl({ url: ""+this.baseUrl + path }), // 移除掉第一個/
          open: false,
        });
      }, 100);
    },
    // 登出事件
    logout() {
      console.log("登出~~~~~~~~~!");
      localStorage.clear(); // 清除登入狀態
      localStorage.setItem("isLogin", "false");
      this.showLogin = true;
      this.showLogout = false;
      location.reload();
    },
    mission(val) {
      //console.log("debug 用 轉址~~~~:" + this.comics_url + this.baseUrl + val);
      window.location.href = this.comics_url + this.baseUrl + val;
    },
  },
  setup(props) {
    let isShowMenu = ref(false);

    const onClickMenu = (me: MouseEvent) => {
      //isShowDetailVideo.value = false; //!isShowDe
      var target = me.target as HTMLElement;
      const displayId = target.getAttribute("displayId") as string;
      //console.log("me:", displayId);
      isShowMenu.value = !isShowMenu.value;
    };
    let isAreaIn = ref(false);
    let isShowLogoutDropDown = ref(false);
    
    const onDisappearPopup = () => {
      let interval = setInterval(() => {
        //console.log("isAreaIn.value:", isAreaIn.value);
        if( false == isAreaIn.value ){
           isShowLogoutDropDown.value = false;
           clearInterval(interval) ;
        }
      }, 8000)
    };
    return {
      onDisappearPopup,
      isAreaIn,
      isShowLogoutDropDown,
      onClickMenu,
      isShowMenu,
    };
  },
};
</script>

<style scoped>
.header {
  width: 100vw;
  text-align: left;
  background-color: black;
  position: fixed;
  z-index: 999;
  top: 0;
  
  height: 54px;
  max-height: 54px;

  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
    height: 54px !important;
    max-height: 54px !important;
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    height: 50px !important;
    max-height: 50px !important;
  }
}
.container {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: left;
  /* justify-content: space-around; */
  height: 100%;
}
.left-container {
  width: 100%;
  position: relative;
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap; */
  /* justify-content: left; */
  cursor: pointer;
}
.logo_img {
  max-width: 264.6px;
  width: 100%;
  display: inline-block;
  position: absolute;
  left: 12px;
  top: 0px;
  margin-top: 11px;

  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
    display: inline-block !important;
    position: absolute !important;
    left: 12px !important;
    top: 0px !important;
    margin-top: 11px !important;
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    position: relative !important;
    display: inline-block !important;
    margin-top: 0px;
    top: -1px !important;
    left: 5% !important;
  }
}
.menu {
  display: inline-block;
  position: absolute;
  right: 12px;
  top: 16.5px;
  width: 17px;
  max-width: 17px;
  margin: 0px;
  margin-left: 88%;
  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
    position: absolute !important;
    /* right: 12px !important; */
    top: 16.5px !important;
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    display: none;
    margin-left: 0px !important;
  }
}
.menu-container-mobile {
  display: flex;
  flex-direction: column;
  padding: 5px;
  align-items: center;
  font-size: 18px;
  position: fixed;
  top: 5px;
  height: 100%;
  width: 100%;
  background-color: black;
  padding: 0px 16px 0px 16px;
  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    display: none !important;
  }
}
.mcm-close {
  position: absolute;
  right: 10px;
  top: 10px;
  padding-right: 15px;
}
.mcm-close-img {
  width: 20px;
  height: 20px;
  margin-top: 6px;
}
.mcm-link {
  width: 100%;
  margin: 10px 10px 10px 10px;
  padding-left: 15px;
}

.mlink-login {
  font-size: 14px;
  font-weight: 500;
  line-height: 17.38px;
  padding: 4px 12px 4px 12px;
  width: 80px;
  height: 25px;
  border-radius: 40px;
  background-color: #326dfb;
  color: white;
}
.mlink {
  font-weight: 500;
  font-size: 14px;
  line-height: 20.27px;
  width: 45px;
  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
    width: 45px !important;
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    width: 45px !important;
  }
}
.menu-container-desktop {
  display: none;
  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
    display: none !important;
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    display: flex !important;
    flex-direction: row;
    padding: 5px;
    align-items: center;
    font-size: 18px;
    height: 22px;
    position: absolute;
    right: 5%;
    top: 15px;
  }
}
.mcd-link {
  cursor: pointer;
}
.debug {
  display: flex;
}
.mlink {
  font-weight: 400;
  font-size: 15px;
  line-height: 21.72px;
  width: 45px;

  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
    width: 45px !important;
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    width: 45px  !important;
  }
}
span {
  color: #fff;
  margin-right: 20px;
}
.nickNameImg {
  background-position: 50%;
  background-size: cover;
  border-radius: 50%;
  display: inline-block;
  height: 30px;
  margin-right: 10px;
  vertical-align: middle;
  width: 30px;
}
.showNNickName {
  margin-top: 5px;
  font-weight: 400;
  font-size: 15px;
  text-align: right;
  color: white;
}
.nickNameArea {
  display: flex;
}
.nickNameArea-d {
  position: fixed !important;
  top: 10px;
  right: 5%;
}
</style>

<style>
.ivu-dropdown-rel {
  position: fixed !important;
  top: 10px;
  right: 5%;
}
.ivu-select-dropdown {
}
.ivu-dropdown-menu {
  position: absolute;

  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    background-color: white;
    /* right: 5%; */
    width: 92px;
    height: 44px;
    /* top: 43.99999999999977px; */
    /* left: 1508px; */
    padding: 4px 12px 4px 12px;
    text-align:center;
    border-radius: 10px;

    font-family: Noto Sans TC;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: cent;

    position: fixed !important;
    top: 48px;
    right: 5%;
  }
}
.dropdown-menu{
  
  position: absolute;

  /*如果螢幕寬度為 800px 以下，就套用 css 設定*/
  @media screen and (max-width: 800px) {
  }
  /*如果螢幕寬度為 800px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 801px) {
    background-color: white;
    /* right: 5%; */
    width: 92px;
    height: 44px;
    /* top: 43.99999999999977px; */
    /* left: 1508px; */
    padding: 10px 12px 4px 12px;
    text-align:center;
    border-radius: 10px;

    font-family: Noto Sans TC;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: cent;

    position: fixed !important;
    top: 48px;
    right: 5%;
  }
}
</style>